import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './plugins/ant-design-vue.js'
import '@/assets/icon/iconfont.css'
import './utils/rem'
import '@/assets/theme-dark.css'
import '@/assets/theme.css'
import '@/assets/config-layout.css'
import '@/assets/market-dialog.css'
import { applyTheme } from '@/utils/theme'
import { applyQuoteColorMode } from '@/utils/quoteColors'

applyTheme(store.state.theme)
applyQuoteColorMode(store.state.quoteColorMode)

Vue.config.productionTip = false
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
